module.exports = __webpack_public_path__ + "img/screen-title.240636a4.png";